<template>
	<div class="price-page">
		<div class="control-panel pt-0">
			<div class="d-flex mb-2">
				<v-tabs class="no-bg mb-3" fixed-tabs>
					<v-tabs-slider></v-tabs-slider>
					<v-tab href="#mobile-tabs-5-1" @click="color = false">
						Черно-белый
					</v-tab>
					<v-tab href="#mobile-tabs-5-2" @click="color = true">
						Цветной
					</v-tab>
				</v-tabs>
			</div>
			<div class="d-flex narrow-chbx">
				<div>
					<!-- @click="generalCard.narrow = !generalCard.narrow"  -->
					<v-checkbox v-model="generalCard.narrow" class="mt-0" dense label="Узкий ценник" />
				</div>
			</div>
			<div class="mb-5">
				<div class="d-flex">
					<PriceCard
						:controls="false"
						class="mb-2 general-card"
						:card="generalCard"
						@edit="generalEdit"
						general
						:color="color"
						:narrow="generalCard.narrow"
					/>
				</div>
				<v-btn small color="#4285f4" dark class="mr-2" @click="createCard">Добавить</v-btn>
			</div>

			<div class="list-add mt-5 mb-5">
				<!-- hint="Поле для вставки из таблицы" -->
				<h3 class="body-1 font-weight-bold">
					Вставить из
					<a
						target="_blank"
						href="https://docs.google.com/spreadsheets/d/1JQq6fQb31gtP9v0iVJ70Gu2LxmoDrD796d1bh4NUhTs/edit#gid=0"
						>таблицы</a
					>
				</h3>
				<v-textarea
					class="mb-2"
					hide-details
					dense
					outlined
					no-resize
					name="list-add"
					v-model="listAdd"
					background-color="#fff"
					:rows="5"
				></v-textarea>
				<v-btn color="#4285f4" dark small @click="listAddClick">Добавить</v-btn>
				<v-btn class="ml-2 erase" small @click="listAdd = ''"> <v-icon>mdi-delete</v-icon></v-btn>
				<v-btn class="ml-2 erase" small @click="exportToSpreadsheet"
					><v-icon>mdi-file-export-outline</v-icon></v-btn
				>
			</div>
			<div class="mt-5">
				<v-btn class="erase" small @click="cards = []">Очистить всё</v-btn>
			</div>
		</div>

		<div class="print-zone">
			<div class="print-list" v-for="(page, i) in pages" :key="'page' + i">
				<div class="annotation">Cтр. {{ i + 1 }}</div>
				<div class="print-list-inner">
					<PriceCard
						v-for="card in page"
						:card="card"
						:key="card.uid"
						:color="color"
						@remove="removeCard(card)"
						:narrow="generalCard.narrow"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PriceCard from '../components/PriceCard'
export default {
	components: {
		PriceCard,
	},
	name: 'PricePage',
	data() {
		return {
			generalCard: {
				type: '',
				title: '',
				description: '',
				price: '1000₽',
				manufactor: 'Китай',
				priceDescription: '',
				date: this.today(),
				seller: 'ИП Петров Е.Л.',
				promo: false,
				narrow: false,
			},
			cards: [],
			color: false,
			listAdd: '',
			uid: 0,
		}
	},
	computed: {
		pages() {
			const tcards = this.cards.map((card, idx) => {
				card.idx = idx
				return card
			})
			const perPage = this.generalCard.narrow ? 42 : 21

			const result = []
			for (let i = 0; i < Math.ceil(tcards.length / perPage); i++) {
				result.push(
					tcards.filter((card, idx) => {
						return idx >= i * perPage && idx < perPage * (i + 1)
					})
				)
			}
			return result
		},
	},
	mounted() {
		this.generalCard.date = this.today()
		// for (let i = 0; i < 1; i++) {
		// 	this.createCard({
		// 		type: 'test',
		// 		title: 'TEST',
		// 		description: 'test\ntest',
		// 		price: '1000₽',
		// 		manufactor: 'Китай',
		// 		priceDescription: 'Цена указана за комплект',
		// 		date: this.today(),
		// 		seller: 'ИП Петров Е.Л.',
		// 		promo: false,
		// 	})
		// }
	},
	methods: {
		today() {
			const date = new Date()
			return `${date
				.getDate()
				.toString()
				.padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`
		},
		createCard(card) {
			this.cards.push({
				...this.generalCard,
				...card,
				uid: this.uid++,
			})
		},
		removeCard(card) {
			const idx = card.idx
			this.cards = this.cards.filter((a, i) => i !== idx)
		},
		listParse() {
			return this.listAdd.split('\n').map(row => row.split('	'))
		},
		listAddClick() {
			this.listParse().forEach(card => {
				this.createCard({
					type: card[0],
					title: card[1],
					description: card[2],
					manufactor: card[3],
					price: card[4],
					priceDescription: card[5],
				})
			})
		},
		exportToSpreadsheet() {
			this.listAdd = this.cards
				.map(card => {
					return [
						card.type,
						card.title,
						card.description,
						card.manufactor,
						card.price,
						card.priceDescription,
					].join('	')
				})
				.join('\n')
		},
		generalEdit(card) {
			this.generalCard = card
		},
	},
}
</script>
<style lang="scss">
.no-bg .v-tabs-bar {
	background-color: transparent !important;
}
.erase {
	color: #4285f4 !important;
}
</style>
<style lang="scss" scoped>
.d-flex {
	display: flex;
}

.price-page {
	font-family: 'Gilroy' !important;
	position: relative;
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: column;
	background-color: #f9f9f9;
	.control-panel {
		transform: scale(1.35);
		transform-origin: top left;
		padding: 1rem;
		background-color: #eee;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		z-index: 100;
		width: 16%;
		min-width: 300px;
		height: 100vh;
	}
	.print-zone {
		transform-origin: top left;
		transform: scale(1.35);
	}
	.print-list {
		// display: flex;
		// justify-content: center;
		// align-items: center;
		background-color: #fff;
		position: relative;
		padding: 32px 55px;
		left: 16%;
		// 22.277
		height: 29.7cm;
		min-height: 29.7cm;
		max-height: 29.7cm;
		border: 1px solid #aaa;
		//15.74cm
		width: 21cm;
		margin-bottom: 15px;
		.annotation {
			position: absolute;
			top: 12px;
			left: 60px;
			font-size: 8px;
		}
	}
	.print-list-inner {
		// height: 29.7cm;
		display: flex;
		// width: 21cm;
		flex-wrap: wrap;
		// align-items: ;
		justify-content: flex-start;
		// align-items: flex-start;
	}

	@media print {
		/* здесь будут стили для печати */
		padding-top: 0;
		.control-panel,
		.annotation {
			display: none;
		}
		.print-zone {
			transform: none;
		}
		.print-list {
			box-sizing: border-box;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			align-items: flex-start;
			padding: 32px 55px;
			height: 29.7cm;
			width: 21cm;
			margin-bottom: 0;
			left: 0;
			border: none;
		}
		.print-list-inner {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			// transform: scale(1.334);
		}
	}
}
</style>
